<div class="form-dialog paragraph-form">
  <h1>Edit Text
    <div (click)="showing_hints=!showing_hints">
      @if (showing_hints) {
        Hide hints
      }
      @if (!showing_hints) {
        Show hints
      }
    </div>
  </h1>
  <mat-dialog-content [ngClass]="{'showing-hints':showing_hints}">
    <mat-tab-group [disableRipple]="true">

      <mat-tab label="Edit Paragraph">
        <div class="form-section column space-between">
          <input #imageUpload type="file" accept="image/*" hidden/>

          <quill-editor
            #quillEditorComponent
            [(ngModel)]="paragraph"
            [modules]="editorModules"
            class="text-editing"
            (click)="adjustTooltip($event)"
            (onEditorCreated)="onEditorCreated($event)">
          </quill-editor>

        </div>

        <!--Easily insert a GSS series tag-->
        @if (allColumns) {
          <div class="row center" style="margin-top:16px;">
            <div (mouseenter)="hint='formula_series'" class="select-search" style="flex-grow:2">
              <select-search-component [label]="'Select a series'"
                [api_model]="'series_light'"
                [(value)]="insert_series"
                [classes]="'fill'"
                (selectionChange)="addToFormula($event)"
                >
              </select-search-component>
            </div>
            <mat-form-field>
              <mat-label>Select a column</mat-label>
              <mat-select (selectionChange)="addToFormula()" [(value)]="insertColumn">
                @for (column of allColumns.columns; track column) {
                  @if (column.deprecated!==true) {
                    <mat-option
                      [value]="column">
                      {{column.title| upperfirst}}
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        <div class="row center" style="margin-top:-20px;">
          <input #copy_string (click)="copyToClipboard(copy_string)" [(ngModel)]="gssInsert"
            class="formula-input"/>
          <i (click)="copyToClipboard(copy_string)" class="fa fa-clipboard"
          style="position:relative;right:26px;" title="Copy to clipboard"></i>
        </div>

      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
  <div class="action-buttons">
    <button (click)="onCloseClick()" class="btn-close">Close</button>
    <!--<button class="btn btn-success" (click)="consoleLog(user)">Console log changes</button>-->
    <button (click)="save()" class="btn-save">Save</button>
  </div>
</div>
